//
//
// BS4 ScrollSpy Fx JS
//
// See: https://www.codeply.com/p/dEpcghWKEm
//

var fn_navanchor_spy = function () {

  // Gets Offset values below for a proper Offset
  var $headerHeight = $('header').outerHeight();
  var $scrolling = $headerHeight;

  $('body').scrollspy({
    target: '.js-scrollspy .anchornav__items',
    offset: $scrolling
  });

};
